import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getCourses } from '../../services/api'; // adjust path as needed

function Courses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    async function fetchCourses() {
      try {
        const res = await getCourses();
        setCourses(res.data);
      } catch (err) {
        console.error(err);
      }
    }

    fetchCourses();
  }, []);

  return (
    <>
      <div className="row pt-2 pb-2">
        <div className="col-sm-9">
          <h4 className="page-title">Courses</h4>
        </div>

        <div className="col-sm-3">
          <div className="btn-group float-sm-right">
            <Link
              to="/dashboard/courses/create"
              className="btn btn-outline-primary waves-effect waves-light"
            >
              <i className="fa fa-cog mr-1"></i> Start a New Course
            </Link>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {courses.length === 0 ? (
            <p>Loading...</p>
          ) : (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>License</th>
                  <th>Visibility</th>
                  <th>Actions</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {courses.map(course => (
                  <tr key={course._id}>
                    <td>
                      <Link to={`/dashboard/courses/${course._id}`}>
                        {course.title}
                      </Link>
                    </td>
                    <td>{course.license}</td>
                    <td>{course.isPublic ? 'Public' : 'Private'} ({course.published ? 'Published' : 'Draft'})</td>
                    <td>
                      <Link to={`/dashboard/courses/${course._id}`} className="btn btn-sm btn-info">
                      <i className="zmdi zmdi-edit"></i> View & Edit
                      </Link>
                    </td>
                    <td>
                      <Link to={`/course/${course._id}`}>
                        <i className="zmdi zmdi-eye"></i>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}

export default Courses;